'use client';

import type { FC } from 'react';
import type { Content } from '@/services/isomorphic/ContentService';
import { DataModelTarget } from '@/services/isomorphic/integrations/BuilderService/schemas';
import { DataModel } from './builder/DataModel';
import { BuilderContent } from './builder/BuilderContent';

import S from './styles.base.module.scss';

export interface IBuilderRenderProps {
  /**
   * The content already fetched from builder.io.
   */
  content: Content;
  /**
   * Optional callback for handling when links are clicked.
   */
  handleLinkClick?: () => void;
}

/**
 * Renders either builder.io content or a data model that is retrieved from builder.io.
 */
export const BuilderRender: FC<IBuilderRenderProps> = ({
  content,
  handleLinkClick
}) => {
  const isDataModel = Object.values<string>(DataModelTarget).includes(
    content.type
  );
  return (
    <div
      // This className and data attributes are expected by the HighPriorityImagesWarning component.
      className={S.contentWrapper}
      data-content-type={content.type}
      data-content-name={content.data?.name}
    >
      {isDataModel ? (
        <DataModel handleLinkClick={handleLinkClick} content={content} />
      ) : (
        <BuilderContent handleLinkClick={handleLinkClick} content={content} />
      )}
    </div>
  );
};

export default BuilderRender;
